export default "__VITE_ASSET__BC5PXhbC__"